export enum ActionBar {
    CREATE_CONVERSATION = 'CREATE_CONVERSATION',
    MANAGE_CONVERSATION = 'MANAGE_CONVERSATION'
}